<template>
  <v-container>
    <v-row>
      <v-col>
        <v-btn
          color="primary"
          class="ma-3"
          :to="profileUrl"
        >Profil</v-btn>
      </v-col>
    </v-row>

    <socialny-podnik-table :editable="true"></socialny-podnik-table>
  </v-container>
</template>


<script>
import { APIService } from "@/http/APIService.js";
import session from "@/api/session";
import SocialnyPodnikTable from './components/SocialnyPodnikTable.vue';
const apiService = new APIService();

export default {
  components: { SocialnyPodnikTable },
  data: () => ({
  }),

  mounted() {
    if (this.$route.params.token)
      session.defaults.headers.Authorization = `Token ${this.$route.params.token}`;
  },

  computed: {
    profileUrl() {
      return `/socialne_podniky/${this.$route.params.token}/profile`;
    }
  },
};
</script>